import React from 'react'
import PostComp from '../../../../components/main/login/mypage/mypost/PostComp'


export const Mypost=() =>{
    return (
        <div>
            <PostComp/>          
        </div>
    )
}
